import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TableModelRequestModel, TableModelResponseModel} from '../../../shared/entities/Table.model';
import {HttpApiService} from '../../../shared/services/http-api.service';
import {DatePipe, DecimalPipe} from '@angular/common';
import {MatDialog, MatDialogConfig, MatDialogRef, MatPaginator} from '@angular/material';
import {ColumnModel} from '../../../shared/components/table/column.model';
import {PageEvent} from '@angular/material/typings/paginator';
import {finalize} from 'rxjs/operators';
import {ApiResponseModel} from '../../../shared/entities/api-response.model';
import {JobTypeService} from '../../services/jobType.service';
import {JobTypeModel} from '../../models/jobType.model';
import {JobService} from '../../services/job.service';
import {CityService} from '../../services/city.service';
import {CountyService} from '../../services/county.service';
import {JobModel} from '../../models/job.model';
import {CreateJobComponent} from '../create-job/create-job.component';
import {UserService} from '../../../auth/services/user.service';
import {ApplyAsStudentComponent} from '../apply-as-student/apply-as-student.component';

@Component({
  selector: 'app-list-jobs',
  templateUrl: './list-jobs.component.html',
  styleUrls: ['./list-jobs.component.scss']
})

export class ListJobsComponent implements OnInit, OnDestroy {

  public loading;
  public dataSource: Array<any>;
  public columns: Array<ColumnModel> = [];

  public selectableRow = false;

  public tableRequestModel: TableModelRequestModel = new TableModelRequestModel();
  public tableResponseModel: TableModelResponseModel = new TableModelResponseModel();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  data: any;
  private selection: any;

  constructor(
      private httpApiService: HttpApiService,
      private datePipe: DatePipe,
      private decimalPipe: DecimalPipe,
      private dialog: MatDialog,
      private jobTypeService: JobTypeService,
      private jobService: JobService,
      private cityService: CityService,
      private countyService: CountyService,
      public userService: UserService,
  ) {

    this.columns.push(new ColumnModel().map( { key: 'id', label: '#', type: 'string' } ));
    this.columns.push(new ColumnModel().map( { key: 'createdByUser.company.name', label: 'Firma', type: 'string' } ));
    this.columns.push(new ColumnModel().map( { key: 'name', label: 'Denumire', type: 'string' } ));
    this.columns.push(new ColumnModel().map( { key: 'jobType.name', label: 'Tip', type: 'string' } ));
    this.columns.push(new ColumnModel().map( { key: 'county.name', label: 'Judet', type: 'string' } ));
    this.columns.push(new ColumnModel().map( { key: 'city.name', label: 'Oras', type: 'string' } ));
    this.columns.push(new ColumnModel().map( { key: 'industry', label: 'Industrie', type: 'string' } ));
    this.columns.push(new ColumnModel().map( { key: 'mandatoryRecommendation', label: 'Cu recomandare', type: 'boolean' } ));
    this.columns.push(new ColumnModel().map( { key: 'created_at', label: 'Adaugata la', type: 'datetime' } ));
    this.columns.push(new ColumnModel().map( { key: 'updated_at', label: 'Modificata la', type: 'datetime' } ));

  }

  ngOnInit(): void {
    this.getData();
  }

  onPageChange(event?: PageEvent): void {
    this.tableRequestModel.per_page = event.pageSize;
    this.tableRequestModel.page = event.pageIndex;
    console.log(event);
    this.getData();
  }

  clearFilters(): void {
    this.tableRequestModel = new TableModelRequestModel();
  }

  onFiltersChange(data: any): void {
    this.clearFilters();
    this.getData();
  }

  getData(): void {
    this.loading = true;
    this.jobService.getTable()
        .pipe(finalize(() => this.loading = false))
        .subscribe((response: ApiResponseModel) => {
          console.log(response);
          this.dataSource = response.payload.data;
          this.tableResponseModel.map(response.payload);
        });
  }

  getElementValue(obj: any, is: any, value?: string): any {

    if (typeof is === 'string'){
      return this.getElementValue(obj, is.split('.'), value);
    } else if (is.length === 1 && value !== undefined){
      return obj[is[0]] = value;
    } else if (is.length === 0) {
      return obj;
    } else {
      return this.getElementValue(obj[is[0]], is.slice(1), value);
    }

  }

  formatValue(value: any, format: string): any {

    switch ( format ) {

      case 'string':
        return value;
        break;

      case 'datetime':
        return this.datePipe.transform(value, 'dd-MM-yyyy HH:mm');
        break;

      case 'float':
        return this.decimalPipe.transform(value, '1.2-2');
        break;

      case 'boolean':
        return (value === true || value === 1) ? 'Da' : 'Nu';
        break;

      default:
        return value;

    }

  }

  getDisplayedColumns(): Array<any> {

    const displayedColumns: Array<any> = [];

    if (this.selectableRow == true){
      displayedColumns.push('select');
    }

    this.columns.forEach((column: ColumnModel) => {
      displayedColumns.push(column.key);
    });


    return displayedColumns;

  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.forEach(row => this.selection.select(row));
  }

  openAddEditEntity(param: JobModel = null): void
  {


    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80vw';
    dialogConfig.height = '80vh';
    dialogConfig.data = param;

    this.dialog.open(CreateJobComponent, dialogConfig).afterClosed().subscribe(result => {
      this.getData();
    });



  }

  onAddNewEntity(): void {
    this.openAddEditEntity();
  }

  onRowSelect(row: any): void
  {
    this.openAddEditEntity(row);
  }

  ngOnDestroy(): void {
  }

}
